import axios from "axios";
import { Dispatch } from "redux";
import { ActionType } from "../action_type";
import { Action } from "../actions/fetchFlightListAction";

import createAuthRefreshInterceptor from "axios-auth-refresh";
import { logOut, refreshAuthLogic } from "../../helper/helper";

export const fetchFlightList = (pageNumber: any) => {
  let getUserLoginInfo = JSON.parse(localStorage.getItem("userLoginInfo") as any) as any;
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.FETCH_FLIGHT_LIST,
    });

    createAuthRefreshInterceptor(axios, refreshAuthLogic);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL_TRIP}/api/v1/trip/airplanes`,
        {
          headers: {
            Authorization: `Bearer ${getUserLoginInfo["access_token"]}`,
          },
          params: {
            lang: "fa",
            pageSize: 10,
            pageNumber: pageNumber,
            sort: "DESC",
            sortKey: "scheduledTime",
          },
        }
      );

      // const names: string[] = data.objects.map((result: any) => {
      //   return result.package.name;
      // });

      dispatch({
        type: ActionType.FETCH_FLIGHT_LIST_SUCCESS,
        payload: data.content,
      });
    } catch (error: any) {
      console.log(error);
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 401) {
          console.log("error status with 401");
          logOut();
        }
        if (error.response.status === 400) {
          console.log("error status with 400");
          logOut();
        }

        if (error.response.status === 404) {
          dispatch({
            type: ActionType.FETCH_FLIGHT_LIST_ERROR,
            payload: ".شناسه وارد شده صحیح نیست، مجددا تلاش بفرمایید",
          });
          return false;
        }
      } else if (error.request) {
        console.log("The request was made but no response was receiveddddd");
        dispatch({
          type: ActionType.FETCH_FLIGHT_LIST_ERROR,
          payload: "لطفا اتصال اینترنت خود را چک کنید.",
        });
        return false;
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log("this is error from ac fetch guild list => ", error);
      dispatch({
        type: ActionType.FETCH_FLIGHT_LIST_ERROR,
        payload: "خطا در سرور",
      });
      return false;
    }
  };
};
